module.exports = __webpack_public_path__ + "img/23-800x800.60f7423e.jpg";